import AnalyticsTracker from "./analytics";
import $ from "jquery";

class AnalyticsService {
    constructor(analytics) {
        this.analytics = analytics;
    }

    trackAll () {
        this.#trackMailAndPhoneClick();
    }

    trackSubscribeToNewsletter() {
        this.analytics.trackSubscribeToNewsletter();
    }

    trackCourseForm(form) {
        const keepFields = [
            'name',
            'quantity',
            'price',
            'transaction_id',
        ];

        const dataCourse = $(form).serializeArray()
            .filter(field => keepFields.includes(field.name))
            .reduce((acc, field) => {
                acc[field.name] = field.value;
                return acc;
            }, {});

        if(dataCourse.transaction_id !== undefined) {
            const item = {...dataCourse};
            item.price = Number(item.price);
            item.quantity = Number(item.quantity);
            delete(item.transaction_id);
            this.analytics.trackPurchase(dataCourse.transaction_id, Number(dataCourse.price), [item]);
        }
    }

    trackContactForm(form) {
        const exceptCommon = [
            '_token',
            'toc_agree',
            'newsletter_agree',
            'newsletter',
            'g-recaptcha-response',
            'hiddenRecaptcha',
            'discipline',
            'submit'
        ];
        const exceptPrivateFields = [
            'email',
            'phone',
            'name',
        ];
        const except = exceptCommon.concat(exceptPrivateFields);

        const data = form.serializeArray()
            .filter(field => !except.includes(field.name))
            .reduce((acc, field) => {
                acc[field.name] = field.value;
                return acc;
            }, {});

        this.analytics.trackContactForm(data);
    }

    #trackMailAndPhoneClick() {
        const analytics = this.analytics;
        $('.ga-track-mail-or-phone-click a[href*="mailto:"]').on('click', function (e) {
            const url = String(e.currentTarget.href).split(':');
            if (url?.[0] === 'mailto') {
                analytics.trackMailClick();
            }
        });

        $('.ga-track-mail-or-phone-click a[href*="tel:"]').on('click', function (e) {
            const url = String(e.currentTarget.href).split(':');
            if (url?.[0] === 'tel') {
                analytics.trackTelClick();
            }
        });

        $('.ga-track-telephone-click-with-this a[href*="tel:"]').on('click', function (e) {
            e.preventDefault();
            analytics.trackTelClick();
            location.href = $(this).attr('href');
        });
    }
}


const analyticsService = new AnalyticsService(new AnalyticsTracker());
export default analyticsService;
